//gitexport const BaseUrl = 'http://localhost:9000/api/v2';
//export const media = "http://localhost:9000/";
//export const mealUrl="http://localhost:9000/MealDetails/"
export const BaseUrl = 'https://api.yaman-restaurant.com/api/v2';
export const media = "https://api.yaman-restaurant.com/";
export const mealUrl="https://yaman-restaurant.com/MealDetails/"